import { useEffect } from 'react';

import { DENTAL_PHOTO_WIDGET_SCROLL_KEY } from '@/shared/config';
import { scrollToElementByID } from '@/shared/lib';

import { DENTAL_PHOTO_WIDGET_ID } from '../config';

type UseDentalPhotoWidgetScrollOptions = {
  patientID: string;
  shouldShowPhotosWidget: boolean;
  dentalPhotoCount: number;
  // Lets the caller mount the photos view first when it is not on screen yet
  onBeforeScroll?: () => void;
};

// The upload modal leaves the patient ID in session storage so the page
// scrolls to the photos widget once the new photos have arrived.
export const useDentalPhotoWidgetScroll = ({
  patientID,
  shouldShowPhotosWidget,
  dentalPhotoCount,
  onBeforeScroll,
}: UseDentalPhotoWidgetScrollOptions): void => {
  useEffect(() => {
    const pendingScrollPatientID = sessionStorage.getItem(
      DENTAL_PHOTO_WIDGET_SCROLL_KEY,
    );

    if (!shouldShowPhotosWidget || pendingScrollPatientID !== patientID) {
      return;
    }

    sessionStorage.removeItem(DENTAL_PHOTO_WIDGET_SCROLL_KEY);
    onBeforeScroll?.();
    setTimeout(() => {
      scrollToElementByID(DENTAL_PHOTO_WIDGET_ID, 'smooth', 'start');
    }, 0);
  }, [patientID, shouldShowPhotosWidget, dentalPhotoCount, onBeforeScroll]);
};
